__turbopack_context__.v({
  "bottom": "Footer-module__mzHgxW__bottom",
  "brand": "Footer-module__mzHgxW__brand",
  "contact": "Footer-module__mzHgxW__contact",
  "container": "Footer-module__mzHgxW__container",
  "credit": "Footer-module__mzHgxW__credit",
  "footer": "Footer-module__mzHgxW__footer",
  "grid": "Footer-module__mzHgxW__grid",
  "links": "Footer-module__mzHgxW__links",
  "logo": "Footer-module__mzHgxW__logo",
  "social": "Footer-module__mzHgxW__social",
  "socialColumn": "Footer-module__mzHgxW__socialColumn",
  "socialItem": "Footer-module__mzHgxW__socialItem",
  "tagline": "Footer-module__mzHgxW__tagline",
});
